const subscriptionBundleNames = {
  yearly: 'Personal News Subscription',
  monthly: 'Monthly News Subscription 2026',
} as const;

export default subscriptionBundleNames;
